import { ChevronRight } from "lucide-react";
import { BlurPopUp, BlurPopUpByWord } from "../animations/PopUpAnimations";

const Hero = () => {
  return (
    <div className="container w-full mx-auto mt-28">
      <h1 className="text-4xl lg:text-7xl">
        <BlurPopUpByWord text="Saurabh Sharma Timilsina" />
      </h1>
      <p className="mt-6 text-2xl lg:text-4xl">
        <BlurPopUpByWord text=" Full Stack Developer." />
      </p>
      <div className="lg:max-w-[84vh]">
        <BlurPopUp delay={1}>
          <p className="mt-6 text-md lg:text-xl text-[#8A8F98]">
            I am a passionate full stack developer with a knack for crafting
            robust and scalable web applications.
          </p>
        </BlurPopUp>
        <BlurPopUp delay={1.1}>
          <p className="mt-4 text-md lg:text-xl text-[#8A8F98]">
            With a passion for web development, I have honed my skills in
            front-end technologies like React.js, as well as back-end
            technologies like Node.js, MySQL, PostgreSQL, and MongoDB.
          </p>
        </BlurPopUp>
      </div>
      <div className="mt-6 flex md:flex-row flex-col items-start md:items-center gap-8">
        <BlurPopUp delay={1.14}>
          <a
            href="/Saurabh's resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download
            className="rounded-xl text-sm gradient-button transition-all text-black p-[10px] duration-150 ease-in-out"
          >
            Download Resume
          </a>
        </BlurPopUp>
        <BlurPopUp delay={1.19}>
          <a
            href="#contact"
            className="text-sm flex items-center justify-center gap-2  hover:bg-[#28282c] rounded-xl py-[10px] px-4"
          >
            <span className="text-transparent bg-clip-text bg-linear-to-r from-white to-[#8A8F98]">
              Contact Me
            </span>
            <ChevronRight className="text-[#8A8F98] w-5 h-5" />
          </a>
        </BlurPopUp>
      </div>
    </div>
  );
};

export default Hero;
